import { LeasingType } from 'modules/types/LeasingOffer';
import { numberToLocaleString } from 'modules/utils';
import i18next from 'i18next';
import { getParticipationAmount } from '../infoCalculation/components/common/helper';

export enum LeasingCalculatorStepForm {
  Success = 'success',
}

export enum InterestRateTypeEnum {
  FIXED = 'fixed',
  VARIABLE = 'variable',
}

export enum LeasingCurrencyEnum {
  HRK = 'HRK',
  EURO = 'EUR',
}

export const getLeasingCalculatorPageUrl = (
  step: number | string,
  tab?: string,
) => {
  const baseUrl = `/leasing-calculator${step ? `/${step}` : ''}`;
  if (tab) {
    return `${baseUrl}/${tab}`;
  }
  return baseUrl;
};

export const getParticipationPropertyByLeasingType = (
  leasingTypeName?: string,
) => {
  if (leasingTypeName === LeasingType.OPERATIONAL) {
    return 'operationalLeasingParticipation';
  }
  return 'financialLeasingParticipation';
};

export const getremainingValuePercentageByLeasingType = (
    leasingTypeName?: string,
) => {
  if (leasingTypeName === LeasingType.OPERATIONAL) {
    return 'remainingValuePercentage';
  }
  return 'leftoverPercentage';
};

export const calculatedFinancingAmountByLeasingType = (
  netoPrice: string,
  ppmv: string,
  taxRate: string,
  leasingType?: string,
  financialParticipationPercentage?: number,
  operationalParticipationPercentage?: number,
) => {
  if (!leasingType) return '';

  // operativni
  // neto
  let objectPrice = +netoPrice;
  let participationPercentage = operationalParticipationPercentage;

  // financijski
  // bruto
  if (leasingType === LeasingType.FINANCIAL) {
    objectPrice += objectPrice * (+taxRate / 100);
    participationPercentage = financialParticipationPercentage;
  }

  const calculatedParticipationAmount = getParticipationAmount(
    objectPrice,
    ppmv,
    participationPercentage?.toString(),
  );

  return numberToLocaleString(
    objectPrice + +ppmv - calculatedParticipationAmount,
  );
};

export const getParticipationAmountLabel = (leasingType?: string) => {
  if (leasingType === LeasingType.OPERATIONAL)
    return i18next.t(
      'leasingCalculator.financialData.operationalParticipationAmount',
    );

  return i18next.t(
    'leasingCalculator.financialData.financialParticipationAmount',
  );
};
